module.exports = __webpack_public_path__ + "img/150.e56a980f.jpg";